import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Star } from 'lucide-react';
import { TRIPADVISOR_LINKS } from '../data/restaurantData';

export const TripAdvisorLogo: React.FC<{ className?: string }> = ({ className = 'h-7 sm:h-8' }) => (
  <div className="flex items-center select-none shrink-0" title="Tripadvisor">
    <svg
      viewBox="0 0 3354.111 713.496"
      className={`${className} w-auto`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Tripadvisor"
    >
      {/* Official Tripadvisor Brand Mark: Trip Green Circle + Black Ollie Mascot */}
      <circle fill="#34E0A1" cx="356.749" cy="356.748" r="356.748" />
      <path
        fill="#000000"
        d="M577.095,287.152l43.049-46.836h-95.465c-47.792-32.646-105.51-51.659-167.931-51.659 c-62.342,0-119.899,19.054-167.612,51.659H93.432l43.049,46.836c-26.387,24.075-42.929,58.754-42.929,97.259 c0,72.665,58.914,131.578,131.579,131.578c34.519,0,65.968-13.313,89.446-35.077l42.172,45.919l42.172-45.879 c23.478,21.764,54.887,35.037,89.406,35.037c72.665,0,131.658-58.913,131.658-131.578 C620.024,345.866,603.483,311.188,577.095,287.152z M225.17,473.458c-49.188,0-89.047-39.859-89.047-89.047 s39.86-89.048,89.047-89.048c49.187,0,89.047,39.86,89.047,89.048S274.357,473.458,225.17,473.458z M356.788,381.82 c0-58.595-42.61-108.898-98.853-130.383c30.413-12.716,63.776-19.771,98.813-19.771s68.439,7.055,98.853,19.771 C399.399,272.962,356.788,323.226,356.788,381.82z M488.367,473.458c-49.188,0-89.048-39.859-89.048-89.047 s39.86-89.048,89.048-89.048s89.047,39.86,89.047,89.048S537.554,473.458,488.367,473.458z M488.367,337.694 c-25.79,0-46.677,20.887-46.677,46.677c0,25.789,20.887,46.676,46.677,46.676c25.789,0,46.676-20.887,46.676-46.676 C535.042,358.621,514.156,337.694,488.367,337.694z M271.846,384.411c0,25.789-20.887,46.676-46.676,46.676 s-46.676-20.887-46.676-46.676c0-25.79,20.887-46.677,46.676-46.677C250.959,337.694,271.846,358.621,271.846,384.411z"
      />
      {/* Official Tripadvisor Typography Wordmark */}
      <path
        fill="#000000"
        d="M3335.258,476.767c-10.404,0-18.854,8.45-18.854,18.854c0,10.404,8.449,18.854,18.854,18.854 c10.402,0,18.854-8.45,18.854-18.854C3354.111,485.217,3345.66,476.767,3335.258,476.767z M3335.258,511.485 c-8.77,0-15.865-7.136-15.865-15.864c0-8.77,7.135-15.864,15.865-15.864c8.77,0,15.904,7.135,15.904,15.864 C3351.162,504.35,3344.027,511.485,3335.258,511.485z M3341.396,492.392c0-3.428-2.432-5.461-6.02-5.461h-6.02v17.18h2.949v-6.218 h3.229l3.109,6.218h3.189l-3.428-6.855C3340.24,496.418,3341.396,494.743,3341.396,492.392z M3335.258,495.222h-2.91v-5.699h2.91 c1.992,0,3.188,0.996,3.188,2.83C3338.445,494.226,3337.211,495.222,3335.258,495.222z M1063.508,285.956v-45.6h-69.914v271.288 h69.914V348.976c0-29.457,18.894-43.927,48.351-43.927h38.266v-64.692h-32.686C1091.849,240.356,1069.607,253.709,1063.508,285.956 z M1215.615,133.053c-23.916,0-42.252,18.894-42.252,42.81c0,23.358,18.336,42.252,42.252,42.252s42.252-18.894,42.252-42.252 C1257.866,151.946,1239.531,133.053,1215.615,133.053z M1180.737,511.645h69.756V240.356h-69.756V511.645z M1582.766,376 c0,77.448-62.779,140.229-140.228,140.229c-31.251,0-59.591-10.244-82.312-27.544v102.601h-69.755V240.356h69.755v22.959 c22.721-17.299,51.061-27.543,82.312-27.543C1519.987,235.772,1582.766,298.552,1582.766,376z M1512.573,376 c0-42.052-34.12-76.173-76.173-76.173s-76.173,34.121-76.173,76.173c0,42.053,34.121,76.173,76.173,76.173 C1478.453,452.173,1512.573,418.093,1512.573,376z M2795.152,352.204l-40.697-11.161c-26.785-6.976-37.189-15.187-37.189-29.337 c0-13.792,14.668-23.438,35.635-23.438c19.971,0,35.635,13.074,35.635,29.815v1.554h64.295v-1.554 c0-49.228-40.139-82.312-99.93-82.312c-59.191,0-102.201,33.044-102.201,78.604c0,35.436,23.477,62.142,64.453,73.223 l38.984,10.643c29.615,8.211,40.617,17.3,40.617,33.603c0,17.18-15.904,28.739-39.582,28.739 c-24.674,0-41.295-15.626-41.295-38.824v-1.555h-68.24v1.555c0,55.645,44.803,94.548,108.979,94.548 c61.822,0,106.705-37.986,106.705-90.283C2861.32,400.354,2849.84,366.793,2795.152,352.204z M1830.219,240.356h69.754v271.288 h-69.754v-22.96c-22.721,17.3-51.062,27.544-82.312,27.544c-77.447,0-140.227-62.78-140.227-140.229s62.78-140.228,140.227-140.228 c31.25,0,59.592,10.244,82.312,27.543V240.356z M1830.219,376L1830.219,376c0-42.092-34.121-76.173-76.174-76.173 s-76.172,34.121-76.172,76.173c0,42.053,34.119,76.173,76.172,76.173C1796.137,452.173,1830.219,418.093,1830.219,376z M2151.85,143.815h69.756v367.869h-69.756v-22.96c-22.721,17.3-51.061,27.544-82.311,27.544 c-77.449,0-140.229-62.78-140.229-140.229s62.779-140.228,140.229-140.228c31.25,0,59.59,10.244,82.311,27.543V143.815z M2151.85,376c0-42.052-34.121-76.173-76.174-76.173c-42.051,0-76.172,34.121-76.172,76.173c0,42.053,34.08,76.173,76.172,76.173 C2117.729,452.173,2151.85,418.093,2151.85,376z M2545.469,511.645h69.754V240.356h-69.754V511.645z M2580.346,133.053 c-23.916,0-42.252,18.894-42.252,42.81c0,23.358,18.336,42.252,42.252,42.252s42.252-18.894,42.252-42.252 C2622.598,151.946,2604.262,133.053,2580.346,133.053z M3162.822,376c0,77.448-62.779,140.229-140.229,140.229 c-77.447,0-140.227-62.78-140.227-140.229s62.779-140.228,140.227-140.228C3100.043,235.772,3162.822,298.552,3162.822,376z M3098.768,376c0-42.052-34.121-76.173-76.174-76.173s-76.172,34.121-76.172,76.173c0,42.053,34.08,76.173,76.172,76.173 C3064.646,452.173,3098.768,418.093,3098.768,376z M1027.793,143.815H760.212v62.222h99.053v305.607h69.516V206.037h99.053v-62.222 H1027.793z M2381.006,437.345l-62.062-196.988h-73.264l93.074,271.288h83.945l93.631-271.288h-73.264L2381.006,437.345z M3265.023,285.956v-45.6h-69.914v271.288h69.914V348.976c0-29.457,18.895-43.927,48.35-43.927h38.266v-64.692h-32.684 C3293.363,240.356,3271.162,253.709,3265.023,285.956z"
      />
    </svg>
  </div>
);

export const TripAdvisorOwlIcon: React.FC<{ className?: string; circleBg?: boolean }> = ({
  className = 'w-6 h-6',
  circleBg = true,
}) => (
  <svg
    viewBox="0 0 714 714"
    className={`${className} shrink-0`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {circleBg && <circle fill="#34E0A1" cx="357" cy="357" r="357" />}
    <path
      fill="#000000"
      d="M577.095,287.152l43.049-46.836h-95.465c-47.792-32.646-105.51-51.659-167.931-51.659 c-62.342,0-119.899,19.054-167.612,51.659H93.432l43.049,46.836c-26.387,24.075-42.929,58.754-42.929,97.259 c0,72.665,58.914,131.578,131.579,131.578c34.519,0,65.968-13.313,89.446-35.077l42.172,45.919l42.172-45.879 c23.478,21.764,54.887,35.037,89.406,35.037c72.665,0,131.658-58.913,131.658-131.578 C620.024,345.866,603.483,311.188,577.095,287.152z M225.17,473.458c-49.188,0-89.047-39.859-89.047-89.047 s39.86-89.048,89.047-89.048c49.187,0,89.047,39.86,89.047,89.048S274.357,473.458,225.17,473.458z M356.788,381.82 c0-58.595-42.61-108.898-98.853-130.383c30.413-12.716,63.776-19.771,98.813-19.771s68.439,7.055,98.853,19.771 C399.399,272.962,356.788,323.226,356.788,381.82z M488.367,473.458c-49.188,0-89.048-39.859-89.048-89.047 s39.86-89.048,89.048-89.048s89.047,39.86,89.047,89.048S537.554,473.458,488.367,473.458z M488.367,337.694 c-25.79,0-46.677,20.887-46.677,46.677c0,25.789,20.887,46.676,46.677,46.676c25.789,0,46.676-20.887,46.676-46.676 C535.042,358.621,514.156,337.694,488.367,337.694z M271.846,384.411c0,25.789-20.887,46.676-46.676,46.676 s-46.676-20.887-46.676-46.676c0-25.79,20.887-46.677,46.676-46.677C250.959,337.694,271.846,358.621,271.846,384.411z"
    />
  </svg>
);

export const GoogleLogo: React.FC<{ className?: string }> = ({ className = 'w-6 h-6' }) => (
  <svg className={`${className} shrink-0`} viewBox="0 0 24 24" aria-label="Google">
    <path
      fill="#4285F4"
      d="M23.745 12.27c0-.7-.06-1.4-.19-2.07H12v4.51h6.6c-.29 1.52-1.14 2.82-2.4 3.68v3.05h3.88c2.27-2.09 3.66-5.17 3.66-9.17z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.88-3.05c-1.08.72-2.45 1.16-4.05 1.16-3.12 0-5.77-2.1-6.72-4.93H1.25v3.15C3.26 21.36 7.34 24 12 24z"
    />
    <path
      fill="#FBBC05"
      d="M5.28 14.27c-.25-.72-.38-1.49-.38-2.27s.13-1.55.38-2.27V6.58H1.25C.45 8.18 0 9.99 0 12s.45 3.82 1.25 5.42l4.03-3.15z"
    />
    <path
      fill="#EA4335"
      d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.34 0 3.26 2.64 1.25 6.58l4.03 3.15c.95-2.83 3.6-4.98 6.72-4.98z"
    />
  </svg>
);

interface TripAdvisorReviewBarProps {
  title?: string;
  subtitle?: string;
  rating?: string;
  reviewCount?: string;
  url?: string;
  googleRating?: string;
  googleReviewCount?: string;
  googleUrl?: string;
  className?: string;
  bannerId?: string;
}

export const TripAdvisorReviewBar: React.FC<TripAdvisorReviewBarProps> = ({
  title = 'Food kiosk and bar',
  subtitle = 'Ramsgate Main Sands',
  rating = '4.9',
  reviewCount = '751 reviews',
  url = TRIPADVISOR_LINKS.restaurant.url,
  googleRating = '4.7',
  googleReviewCount = '75+ reviews',
  googleUrl = 'https://maps.google.com/?q=Frankie%E2%80%99s+%40+the+beach+Ramsgate',
  className = '',
  bannerId = 'tripadvisor-review-bar',
}) => {
  return (
    /* Edge-to-edge full width review bar with zero outer white space */
    <div id={bannerId} className={`w-full bg-white relative my-0 ${className}`}>
      {/* Top thick blue stripe running full width edge-to-edge */}
      <div className="h-2 sm:h-2.5 bg-[#0050D8] w-full" />

      {/* Clean Content Row - Centralized in the middle */}
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-3.5 flex flex-wrap md:flex-nowrap items-center justify-center gap-3.5 sm:gap-5 md:gap-6 lg:gap-7">
        
        {/* 1. TripAdvisor Section */}
        <div className="flex items-center gap-2.5 sm:gap-3.5 shrink-0">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity flex items-center shrink-0"
            title="View on TripAdvisor"
            aria-label="TripAdvisor"
          >
            <TripAdvisorLogo className="h-6 sm:h-7.5" />
          </a>

          {/* Rating (4.9), 5 Green Circles & Reviews Count */}
          <div className="flex items-center gap-2 shrink-0">
            <span className="text-2xl sm:text-3xl font-black text-gray-950 font-sans tracking-tight leading-none">
              {rating}
            </span>
            <div className="flex flex-col">
              {/* 5 solid TripAdvisor green circles */}
              <div className="flex items-center gap-1" title={`${rating} out of 5 bubbles`}>
                {[1, 2, 3, 4, 5].map((bubble) => (
                  <span
                    key={bubble}
                    className="w-3 h-3 sm:w-3.5 sm:h-3.5 rounded-full bg-[#00AA6C] inline-block shadow-2xs"
                  />
                ))}
              </div>
              <span className="text-[10.5px] sm:text-xs font-semibold text-gray-800 tracking-tight mt-0.5 whitespace-nowrap">
                Excellent · {reviewCount}
              </span>
            </div>
          </div>
        </div>

        {/* Vertical divider */}
        <div className="hidden sm:block h-8 w-px bg-gray-300/80 shrink-0" />

        {/* 2. Google Reviews Section with Official 4-Color Logo */}
        <a
          href={googleUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2.5 sm:gap-3 shrink-0 hover:opacity-90 transition-opacity group cursor-pointer"
          title="View Frankie's on Google Reviews"
          aria-label="Google Reviews"
        >
          <div className="flex items-center gap-2 shrink-0">
            <GoogleLogo className="w-5 h-5 sm:w-6 sm:h-6" />
            <span className="text-2xl sm:text-3xl font-black text-gray-950 font-sans tracking-tight leading-none">
              {googleRating}
            </span>
          </div>
          <div className="flex flex-col">
            {/* 5 Google Stars */}
            <div className="flex items-center gap-0.5 text-amber-400" title={`${googleRating} out of 5 stars`}>
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className="w-3 h-3 sm:w-3.5 sm:h-3.5 fill-amber-400 text-amber-400"
                />
              ))}
            </div>
            <span className="text-[10.5px] sm:text-xs font-semibold text-gray-800 tracking-tight mt-0.5 whitespace-nowrap group-hover:text-blue-600 transition-colors">
              Google · {googleReviewCount}
            </span>
          </div>
        </a>

        {/* Vertical divider */}
        <div className="hidden lg:block h-8 w-px bg-gray-300/80 shrink-0" />

        {/* 3. Title & Location ("Food kiosk and bar / Ramsgate Main Sands") */}
        <div className="text-center md:text-left shrink-0 hidden sm:block">
          <h3 className="text-xs sm:text-sm md:text-base font-bold text-gray-900 leading-tight">
            {title}
          </h3>
          <p className="text-[10px] sm:text-xs text-gray-500 font-medium leading-tight mt-0.5">
            {subtitle}
          </p>
        </div>

        {/* 4. Action Button ("Read our reviews ↗") */}
        <div className="shrink-0">
          <Link
            to="/reviews"
            className="inline-flex items-center justify-center gap-1.5 sm:gap-2 bg-[#18181B] hover:bg-black active:scale-95 text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl font-bold text-xs sm:text-sm shadow-xs transition-all cursor-pointer whitespace-nowrap"
            title="Read all reviews (TripAdvisor & Google)"
          >
            <span>Read our reviews</span>
            <ExternalLink className="w-3.5 h-3.5 stroke-[2.2]" />
          </Link>
        </div>

      </div>

      {/* Bottom thick blue stripe running full width edge-to-edge */}
      <div className="h-2 sm:h-2.5 bg-[#0050D8] w-full" />
    </div>
  );
};

export const TripAdvisorMainBanner: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <TripAdvisorReviewBar
      bannerId="tripadvisor-banner-restaurant"
      title="Food kiosk and bar"
      subtitle="Ramsgate Main Sands"
      rating="4.9"
      reviewCount="751 reviews"
      url={TRIPADVISOR_LINKS.restaurant.url}
      className={className}
    />
  );
};

export const TripAdvisorAttractionsBanner: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <TripAdvisorReviewBar
      bannerId="tripadvisor-banner-attractions"
      title="Children's beach rides & amusements"
      subtitle="Ramsgate Main Sands"
      rating="4.9"
      reviewCount="270 reviews"
      url={TRIPADVISOR_LINKS.attractions.url}
      className={className}
    />
  );
};

// Default export alias for backward compatibility across all pages
export const TripAdvisorBanner: React.FC = () => {
  return <TripAdvisorMainBanner />;
};
